<template>
  <div class="locationBin" :class="{'itemLoaded': nonempty }" :title="binTitle" @click="showDetails" />
</template>

<script>
export default {
  name: 'Bin',
  props: {
    bin: {
      type: Object,
      required: false
    }
  },
  data: () => ({
  }),
  computed: {
    binTitle() {
      return this.bin?.label || ''
    },
    items() {
      return this.bin?.items || []
    },
    nonempty () {
      return !!this.bin?.totalItems
    }
  },
  methods: {
    showDetails() {
      const requestData = {
        bin: this.bin
      }
      this.$emit('show-bin-items', requestData)
    }
  }
}
</script>

<style lang="scss">
.locationBin {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: rgba(118, 113, 189, 0.2);

  &.itemLoaded {
    background-color: rgba(118, 113, 189, 1);
  }
}
</style>

<style scoped lang="scss">
.locationBin {
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 0 5px rgba(118, 113, 189, 0.5);
  }
}
</style>
